import i18n, { type TFunction } from "i18next";

export type TEmailBuilderValidationMessageValue = string | TEmailBuilderValidationMessageDescriptor;

export type TEmailBuilderValidationMessageDescriptor = {
  key: string;
  values?: Record<string, TEmailBuilderValidationMessageValue>;
  literalValues?: Record<string, string>;
};

function asTranslatedString(result: ReturnType<TFunction>): string {
  return typeof result === "string" ? result : String(result);
}

function translateValue(
  value: TEmailBuilderValidationMessageValue,
  t: TFunction,
): string {
  if (typeof value === "string") {
    return asTranslatedString(t(value));
  }

  return translateEmailBuilderValidationMessage(value, t);
}

export function translateEmailBuilderValidationMessage(
  message: TEmailBuilderValidationMessageDescriptor | string,
  t: TFunction = i18n.t.bind(i18n),
): string {
  if (typeof message === "string") {
    return asTranslatedString(t(message));
  }

  const literalValues = message.literalValues ?? {};
  const translatedValues: Record<string, string> = {};
  if (message.values) {
    for (const [key, value] of Object.entries(message.values)) {
      translatedValues[key] = translateValue(value, t);
    }
  }

  return asTranslatedString(
    t(message.key, {
      ...literalValues,
      ...translatedValues,
    }),
  );
}
